import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  SmartTooltip,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";

const VideoInterviewAddUsersModal = ({
  showAddUsersModal,
  setShowAddUsersModal,
}) => {
  const [openToggle, setOpenToggle] = useState(false);
  const options = [
    { label: "Per Day", value: "Per Day" },
    { label: "Per Week", value: "Per Week" },
    { label: "Per Month", value: "Per Month" },
    { label: "Fixed", value: "Fixed" },
  ];
  const rows = [
    {
      WhoCanUse: "Mohsin Usman",
      Assigned: 5,
      NoOfMeetingsCreated: 0,
    },
    {
      WhoCanUse: "Hema",
      Assigned: 5,
      NoOfMeetingsCreated: 0,
    },
    {
      WhoCanUse: "Raghuveer Bandi",
      Assigned: 3,
      NoOfMeetingsCreated: 0,
    },
    {
      WhoCanUse: "Vikranth Reddy",
      Assigned: 5,
      NoOfMeetingsCreated: 0,
    },
    {
      WhoCanUse: "Nikolas",
      Assigned: 5,
      NoOfMeetingsCreated: 0,
    },
    {
      WhoCanUse: "Thrilok",
      Assigned: 7,
      NoOfMeetingsCreated: 0,
    },
    {
      WhoCanUse: "Justin",
      Assigned: 5,
      NoOfMeetingsCreated: 0,
    },
  ];

  const columns = [
    {
      key: "WhoCanUse",
      label: "Who Can Use",
      width: 150,
      render: (row) => (
        <div className="flex gap-4 items-center">{row.WhoCanUse}</div>
      ),
    },
    {
      key: "Assigned",
      label: "Assigned",
      minWidth: 250,
      render: (row) => (
        <FormFieldSet type="text" value={row.Assigned} noTitle size="sm" />
      ),
    },
    {
      key: "Duration",
      label: "Duration",
      width: 250,
      render: (row) => (
        <FormFieldSet type="select" placeholder="Select" noTitle size="sm" options={options}/>
      ),
    },
    {
      key: "Access",
      label: "Access",
      width: 150,
      render: (row) => (
        <SmartTooltip description={"Toggle"} noicon>
          <Button
            type="icon"
            variant="text"
            icon="toggle_on"
            color="black"
            size="sm"
          />
        </SmartTooltip>
      ),
    },
    {
      key: "NoOfMeetingsCreated",
      label: "No Of Meetings Created",
      width: 150,
      render: (row) => (
        <div className="text-info cursor-pointer">
          {row.NoOfMeetingsCreated}
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);
  return (
    <Modal
      title="User List"
      isOpen={showAddUsersModal}
      onClose={() => setShowAddUsersModal(false)}
      width="max-w-4xl"
      titleColor={"primary"}
    >
      <div className=" p-5 shadow-md">
        <TableAdv
          columns={columns}
          rows={mappedRows}
          toolbarRight={{
            search: true,
            add: [
              {
                component: (
                  <FormFieldSet
                    type="toggle"
                    noTitle
                    size="xs"
                    isChecked={openToggle}
                    onChange={setOpenToggle}
                    label={"Assigned Users Only"}
                  />
                ),
              },
            ],
          }}
        />
        <div className="flex justify-end items-center gap-3 mt-10">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => setShowAddUsersModal(false)}
          />
          <Button title={"Save"} />
        </div>
      </div>
    </Modal>
  );
};

export default VideoInterviewAddUsersModal;
